export default __webpack_public_path__ + "static/media/DNo.14-0.b24d7f2f.jpg";